import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";

interface ConfirmDeleteModalProps<T> {
  open: boolean;
  row: T | null;
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
  getTitle?: (row: T) => string;
}

const ConfirmDeleteModal = <T,>({
  open,
  row,
  loading,
  onConfirm,
  onClose,
  getTitle,
}: ConfirmDeleteModalProps<T>) => {
  const [localRow, setLocalRow] = useState<T | null>(row);

  useEffect(() => {
    if (open && row) {
      setLocalRow(row);
    }
  }, [open, row]);

  const title = localRow && getTitle ? getTitle(localRow) : "this item";

  return (
    <Dialog
      open={open}
      onClose={() => {
        if (!loading) {
          onClose();
        }
      }}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete <strong>{title}</strong>?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          disabled={loading}
          startIcon={loading && <CircularProgress size={20} />}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteModal;
